var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('banner-1'),_c('session-1'),_c('session-2'),_c('session-3'),_c('session-4'),_c('div',{staticStyle:{"height":"80px"}},[_c('to-top')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }